// extracted by mini-css-extract-plugin
export default {"bodyHome":"Login_bodyHome__FyloR","container":"Login_container__+Ihqx","logoImage":"Login_logoImage__Sq8gf","form":"Login_form__HoQ6M"};